module.exports = __webpack_public_path__ + "static/img/logo_3.951f9c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_3.png
// module id = 8h5J
// module chunks = 1